import { handleGetClass } from 'store/classes/thunks';
import { handleListChapterActivities } from 'store/activities/thunks';
import { handleListChapterQuizzes } from 'store/quizzes/thunks';
import { handleListBookOrder, handleListBooksByIds } from 'store/books/thunks';
import { listBooksByIdsSuccess } from 'store/books/actions';

export const handleDeepLinkRedirect = async (dispatch, redirectData, redirect_path) => {
    let shouldUseDashboard = false;
    let finalRedirectPath = redirect_path;
    
    if (redirectData && redirectData.class_id) {
        try {
            const classIdToCheck = redirectData.class_id;
            const getCurrectClass = await dispatch(handleGetClass(classIdToCheck));
            
            if ((getCurrectClass && getCurrectClass.success|| getCurrectClass?.id) && redirectData.chapter && redirectData.page) {
                const [, , , booksResponse] = await Promise.all([
                    dispatch(handleListBookOrder()),
                    dispatch(handleListChapterActivities(redirectData.chapter)),
                    dispatch(handleListChapterQuizzes(redirectData.chapter)),
                    dispatch(handleListBooksByIds([redirectData.chapter]))
                ]);
                const BookInfo = booksResponse && booksResponse.success ? booksResponse.data : [];
                if (BookInfo && Array.isArray(BookInfo) && BookInfo.length > 0) {
                    await dispatch(listBooksByIdsSuccess(BookInfo));
                }
            }
            
            if (redirectData.path) {
                finalRedirectPath = redirectData.path;
            } else {
                shouldUseDashboard = true;
            }
        } catch (error) {
            console.error('Error activating deep link class:', error);
        }
    }
    
    return { shouldUseDashboard, redirectPath: finalRedirectPath };
};
